import { ErrorBoundary } from '@sentry/react';
import { useCrossPlatformNavigationItems } from '@/hooks/navigation/useCrossPlatformNavigationItems';
import { SideNavLinks } from '../common/SideNavLinks';
import { FallbackSideNavLinks } from '../fallback/FallbackSideNavLinks';

const CrossPlatformSideNavLinksWithData = () => {
  const { primary } = useCrossPlatformNavigationItems();
  return <SideNavLinks navItems={primary} />;
};

export const CrossPlatformSideNavLinks = () => (
  <ErrorBoundary fallback={<FallbackSideNavLinks />}>
    <CrossPlatformSideNavLinksWithData />
  </ErrorBoundary>
);
